var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgQuoteBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2857 6.21739H21.6667H20.3571C19.6369 6.21739 19.0476 5.63043 19.0476 4.91304V1L24.2857 6.21739Z",
    fill: "#D8D8D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98822 4.91284H10.5358",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98822 7.52173H5.29774",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60712 7.52173H7.91664",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2857 29.6957C24.2857 30.413 23.6964 31 22.9762 31H2.02382C1.30358 31 0.714294 30.413 0.714294 29.6957V2.30435C0.714294 1.58696 1.30358 1 2.02382 1H19.0476L24.2857 6.21739V29.6957Z",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 6.21739H20.3571C19.6369 6.21739 19.0476 5.63043 19.0476 4.91304V1",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.012 26.9091H19.7025",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3927 26.9091H17.0832",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4644 26.9091H3.98822",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteBlank);
export default __webpack_public_path__ + "static/media/quote-blank.f077d79223922d87f9b646cec1165b16.svg";
export { ForwardRef as ReactComponent };